// register the plugin on vue
import Vue from 'vue';
import Toasted from 'vue-toasted';
import '@/sass/toasted.sass'

Vue.use(Toasted, {
  iconPack : 'mdi'
})

const message = (payload) => {
  if(! payload.message) {
    return "Oops.. Something Went Wrong.."
  }
  return payload.message
}

Vue.toasted.register('success', message, {
    position: 'top-center',
    duration: 3000,
    keepOnHover: true,
    singleton: true,
    icon: 'mdi-check-bold',
    className: ['vue__toasted', 'toasted__success'],
    action:{
      icon: 'mdi-close',
      class: 'toasted__action__class',
      onClick: function(e, toastObject){
        toastObject.goAway(0);
      }
    }
  }
)

Vue.toasted.register('error', message, {
  position: 'top-center',
  duration: 3000,
  keepOnHover: true,
  singleton: true,
  icon: 'mdi-alert-circle-outline',
  className: ['vue__toasted', 'toasted__error'],
  action:{
    icon: 'mdi-close',
    class: 'toasted__action__class',
    onClick: function(e, toastObject){
      toastObject.goAway(0);
    }
  }
})

Vue.toasted.register('error_eternal', message, {
  position: 'top-center',
  keepOnHover: true,
  singleton: true,
  icon: 'mdi-alert-circle-outline',
  className: ['vue__toasted', 'toasted__error'],
  action:{
    icon: 'mdi-close',
    class: 'toasted__action__class',
    onClick: function(e, toastObject){
      toastObject.goAway(0);
    }
  }
})
